export default {
  "messageBox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message Box"])},
  "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More"])},
  "noMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No message yet"])},
  "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages"])}
}